/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, ExtendContainerProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '../UIText';

export type PopupHeaderProps = ExtendContainerProps<{
    headerId: string;
    headerMaxWidth?: number;
}>;

export const $PopupHeader: FC<PopupHeaderProps> = (props) => {
    return <$UIText
        localeID={props.headerId}
        stylePreset='POPUP_HEADER'
        maxWidth={props.headerMaxWidth}
        name='popup_heder'
        responsive={{
            box: {x: '50%'},
            translate: {y: '144px'}
        }}
    />;
};